<template>
  <div class="layout-center-wrap">
    <!-- 상단 타이틀 -->
    <section class="page-tit__wrap">
      <h1 class="page-tit__sub">취약점 제보</h1>
      <p class="page-tit">핵더챌린지 분석플랫폼 접속</p>
    </section>
    <section class="section-pt" aria-labelledby="intro-heading">
      <h2 id="intro-heading" class="section-title">
        핵더 챌린지 분석 플랫폼 신청 안내
      </h2>
      <div class="notice-box">
        <p class="notice-box__tit">
          한국인터넷진흥원은 신규 보안취약점 발굴을 위해 핵더챌린지 분석
          플랫폼을 운영하고 있습니다.
        </p>
        <p class="notice-box__text">
          핵더챌린지 분석플랫폼은 클라우드 서버를 기업에 제공하여 분석 대상
          소프트웨어/서비스를 클라우드 서버 내 설치 후 민간 보안 전문가에게
          개방하는 플랫폼으로써 인터넷 접속이 불가한 폐쇄된 환경(VDI,
          가상데스크톱)이 민간보안전문가에게 제공되고 이를 통해 취약점 발굴을
          진행합니다.
        </p>
        <p class="notice-box__text">
          핵더챌린지 분석플랫폼에 대한 자세한 사항은 "KNVD 소개 → 핵더챌린지
          분석플랫폼"을 참고 부탁드립니다.
        </p>
        <p class="notice-box__text">
          핵더챌린지 분석플랫폼 이용 신청을 위해서는 아래 “핵더챌린지 플랫폼
          접속“을 버튼을 이용하여 접속하시기 바랍니다.
        </p>
        <p class="notice-box__text">
          기타 문의사항 - 한국인터넷진흥원 취약점분석팀 vuln_notice@boho.or.kr
        </p>
      </div>
      <p class="pdt20" />
      <p class="notice-box__text">
        ※ 대검찰청, 경찰청, 인터넷진흥원, 금융기관 등을 사칭하는
        <span class="red"
          ><strong
            >피싱사이트, 피싱 문자로 인한 금전적 피해가 발생하고
            있습니다.</strong
          >
          <br />

          <strong>
            &ensp; 사이트 접속 시 바로 개인정보를 입력하지 말고 먼저 사이트
            주소를 확인하시기 바랍니다.
          </strong></span
        >
      </p>
    </section>
    <div class="pdt20" />
    <button
      type="button"
      class="btn btn--blue btn--m center"
      v-on:click="accessPlatform"
    >
      핵더챌린지 플랫폼 접속
    </button>
  </div>
</template>

<script>
import { inject } from "vue";
import { useStore } from "vuex";
import dc from "@/component/DataChk.js";
import gt from "@/component/GetTokenValue.js";

export default {
  setup() {
    const axios = inject("axios");
    const store = useStore();

    const showLoading = () => store.dispatch("loading/show");
    const hideLoading = () => store.dispatch("loading/hide");

    //methods 정의
    const accessPlatform = () => {
      showLoading();
      const userId = gt.getUser();
      axios
        .post("/core/pr/member/hack/get", { userId })
        .then((res) => {
          if (res.data.resType === "RES_OK") {
            const token = res.data.resMsg;
            if (dc.nullChk(token)) {
              const formData = new URLSearchParams();
              formData.append("userId", userId);
              formData.append("token", token);
              formData.append("Authority", 1);
              axios.post(process.env.VUE_APP_HACK_URL, formData);
            } else {
              alert("핵더챌린지 분석플랫폼 접근이 불가능합니다.");
            }
          } else {
            alert(res.data.resMsg);
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          hideLoading();
        });
    };

    // html에서 사용될 데이터 정의
    return { accessPlatform };
  },
};
</script>

